var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5084 16.6965C17.5667 16.6965 20.8566 13.4066 20.8566 9.34824C20.8566 5.28992 17.5667 2 13.5084 2C9.45008 2 6.16016 5.28992 6.16016 9.34824C6.16016 13.4066 9.45008 16.6965 13.5084 16.6965Z",
    stroke: "#1463AB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 27.292C2.23486 24.4189 3.53587 21.7375 5.64731 19.775C7.75874 17.8124 10.5279 16.7105 13.4105 16.686C16.2931 16.6614 19.0806 17.7159 21.2251 19.6422C23.3697 21.5686 24.7162 24.2274 25 27.096",
    stroke: "#1463AB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanIcon);
export default __webpack_public_path__ + "static/media/humanIcon.85c9cb75af1f40011ede88bcc00475a3.svg";
export { ForwardRef as ReactComponent };